import type { UpdatesConfig, Cache } from '@urql/exchange-graphcache';
import { GetPreparedBasketDocument } from '../generated/shopping/GetPreparedBasketDocument';
import type { GetPreparedBasketQueryVariables } from '../generated/shopping/graphql';

/**
 * After any updatePreparedBasket mutation, write the result into all cached
 * getPreparedBasket query entries so every subscribed component re-renders
 * with fresh data without an additional network request.
 *
 * We update ALL cached pages (not just the mutated one) because the basket
 * state is consistent across pages and page-specific fields (e.g. allowed
 * payments) are already captured in the mutation response for the given page.
 */
const updateAllPreparedBasketQueries = (result: Record<string, unknown>, cache: Cache): void => {
  const mutationResult = result.updatePreparedBasket;
  if (!mutationResult) return;

  cache
    .inspectFields('Query')
    .filter((field) => field.fieldName === 'getPreparedBasket')
    .forEach((field) => {
      cache.updateQuery(
        {
          query: GetPreparedBasketDocument,
          variables: field.arguments as GetPreparedBasketQueryVariables,
        },
        () => ({ getPreparedBasket: mutationResult }),
      );
    });
};

export const preparedBasketCacheUpdates: UpdatesConfig['Mutation'] = {
  updatePreparedBasket: (result, _args, cache) => {
    updateAllPreparedBasketQueries(result as Record<string, unknown>, cache);
  },
};
